import csrheroImage from "../assets/csrhero.png";
import "./OurCSR.css";
import csrImage1 from "../assets/environmental-protection-and-sustainability.png";
import csrImage2 from "../assets/education-and-support-for-underprivileged-children.png";
import csrImage3 from "../assets/holistic-development-and-child-welfare.png";
import csrImage4 from "../assets/committees-and-program-implementation.png";

function OurCSR() {
  return (
    <>
      {/* 🔵 HERO SECTION (background image only) */}
      <section
        className="ourCSR-hero"
        style={{ backgroundImage: `url(${csrheroImage})` }}
      >
       {/*<h1 className="hero-title">Our CSR Initiatives</h1>*/} 
      </section>

      {/* ⚪ CONTENT SECTION (below hero) */}
      <section className="csr-content">
        {/*1*/}
        <div className="csr-section">

          <div className="csr-left">
            <div className="csr-number">01</div>

            <h2>Environmental Protection and Sustainability</h2>

            <ul>
              <li>To promote protection, preservation, and improvement of the natural environment, including air, water, soil, forests, and biodiversity.</li>
              <li>To undertake and support programs related to environmental awareness, climate action, waste management, tree plantation, water conservation, renewable energy, and sustainable living practices.</li>
              <li>To collaborate with government bodies, local authorities, educational institutions, and other organizations to implement environmental conservation initiatives.</li>
            </ul>
          </div>

          <div className="csr-right">
            <img src={csrImage1} alt="CSR" />
          </div>

        </div>
         {/*2*/}
         <div className="csr-section">
          <div className="csr-right">
            <img src={csrImage2} alt="CSR" />
          </div>
          <div className="csr-left">
            <div className="csr-number">02</div>

            <h2>Education and Support for Underprivileged Children</h2>

            <ul>
              <li>To provide educational support to underprivileged, marginalized, and economically weaker children, including access to quality education.</li>
              <li>To establish, support, or assist schools, learning centers, libraries, and digital learning facilities for children from disadvantaged backgrounds.</li>
              <li>To provide scholarships, school supplies, uniforms, books, learning materials, transportation support, and other educational aids to deserving students.</li>
              <li>To organize remedial classes, skill development programs, vocational training, mentoring, and career guidance for children and youth.</li>
            </ul>
          </div>
        </div>

        {/*3*/}
        <div className="csr-section">

          <div className="csr-left">
            <div className="csr-number">03</div>

            <h2>Holistic Development and Child Welfare</h2>

            <ul>
              <li>To promote the overall development of children through health, nutrition, sports, arts, culture, and life-skills programs.</li>
              <li>To conduct awareness programs for parents and communities on child rights, education, health, hygiene, and social responsibility.</li>
              <li>Community Development and Social Welfare.</li>
              <li>To support community development initiatives aimed at improving living standards, self-reliance, and social inclusion of underprivileged groups.</li>
              <li>To provide assistance during natural disasters, emergencies, and humanitarian crises through relief, rehabilitation, and reconstruction activities.</li>
            </ul>
          </div>

          <div className="csr-right">
            <img src={csrImage3} alt="CSR" />
          </div>
        </div>

       {/*4*/}
          <div className="csr-section">
          <div className="csr-right">
            <img src={csrImage4} alt="CSR" />
          </div>
          <div className="csr-left">
            <div className="csr-number">04</div>

            <h2>Committees and Program Implementation</h2>

            <ul>
              <li>To constitute various committees, advisory boards, working groups, or task forces as may be required for effective planning, implementation, monitoring, and evaluation of Trust activities.</li>
              <li>To engage professionals, volunteers, educators, environmental experts, and social workers to support the objectives of the Trust.</li>
              <li>Collaboration and Support Activities.</li>
              <li>To seek, receive, and utilize grants, donations, contributions, and support (financial or in-kind) from individuals, institutions, corporations, government agencies, and international organizations, subject to applicable laws.</li>
              <li>To partner with other non-governmental organizations, trusts, societies, and institutions having similar objectives for joint programs and initiatives.</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default OurCSR;